import React from 'react';
import HeroSection from '../components/HeroSection';
import ServicesSection from '../components/ServicesSection';
import AmazonSection from '../components/AmazonSection';
import PricingSectionV2 from '../components/PricingSectionV2';
// import HowItWorksSection from '../components/HowItWorksSection';
import WhyChooseUsSection from '../components/WhyChooseUsSection';
import TestimonialsSection from '../components/TestimonialsSection';
import CTASection from '../components/CTASection';
import {
  selfFilingProcessCards,
  attorneyLedProcessCards,
  selfFilingPlans,
  attorneyLedPlans,
} from '../mock';

const Home = ({ onOpenModal }) => {
  return (
    <div className="min-h-screen">
      <HeroSection onOpenModal={onOpenModal} />
      <ServicesSection />
      {/* <HowItWorksSection /> */}
      <AmazonSection onOpenModal={onOpenModal} />
      <PricingSectionV2
        onOpenModal={onOpenModal}
        selfFilingProcessCards={selfFilingProcessCards}
        attorneyLedProcessCards={attorneyLedProcessCards}
        selfFilingPlans={selfFilingPlans}
        attorneyLedPlans={attorneyLedPlans}
      />
      <WhyChooseUsSection />
      <TestimonialsSection />
      <CTASection onOpenModal={onOpenModal} />
    </div>
  );
};

export default Home;
